import React from "react";
import { Box, Typography, IconButton } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import store from "../../../assets/images/SVG/store.svg"

import * as routes from "../../../constants/routes";

const CardContainer = styled(Box)(({ theme }) => ({
  backgroundColor: "#ffffff",
  borderRadius: "6px",
  padding: "17px",
  height: "100%",
  display: "flex",
  flexDirection: "column",
  gap: "16px",
  cursor: "pointer",
  transition: "all 0.2s ease-in-out",
  border: "3px solid transparent",

  "&:hover": {
    backgroundColor: "#ede3f5",
    border: `3px solid ${theme.palette.primary.main}`,
    padding: "17px",
    "& .default-text": {
      display: "none",
    },
    "& .hover-text": {
      display: "block !important",
    },
  },
}));

const IconWrapper = styled(Box)({
  width: "60px",
  height: "60px",
  borderRadius: "12px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
});

const Title = styled(Typography)({
  fontFamily: "Montserrat, sans-serif",
  fontWeight: 600,
  // fontSize: "16px",
  // lineHeight: "160%",
  letterSpacing: "0.17px",
  color: "#333333",
});

const Description = styled(Typography)({
  color: "#666666",
  // fontSize: "15px",
});

const CoinStoreCard = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleClick = () => {
    navigate(routes.R_COINSTORE);
  };

  return (
    <CardContainer onClick={handleClick}>
      <Box sx={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between" }}>
        <IconWrapper>
          <Box
            component="img"
            src={store}
            alt="icone que representa uma loja"
            sx={{
              width: "60px",
              height: "60px"
            }}
          />
        </IconWrapper>
        <IconButton size="small" sx={{ color: "#333333", padding: "4px" }}>
          <ArrowForwardIcon fontSize="small" />
        </IconButton>
      </Box>
      <Box sx={{ flex: 1, display: "flex", flexDirection: "column", justifyContent: "center", gap: "10px" }}>
        <Title sx={{
          fontSize: { xs: "12px", sm: "16px" },
          lineHeight: { xs: "13px", sm: "16px" },
        }}
        >
          {t("global.afinando_store")}
        </Title>
        <Description className="default-text" sx={{ fontSize: { xs: "11px", sm: "15px" } }}>{t("global.exchange_your_crystals")}</Description>
        <Typography
          className="hover-text"
          sx={{
            display: "none",
            color: "#662D91",
            fontSize: "13px",
            fontWeight: 700,
            textTransform: "uppercase",
            textDecoration: "underline",
          }}
        >
          {t("global.access_store")}
        </Typography>
      </Box>
    </CardContainer>
  );
};

export default CoinStoreCard;
